import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

// API PascalCase döner (Startup.cs: PropertyNamingPolicy = null).
export interface IIyzicoInstallment {
  Id: number
  TaksitSayisi: number
  Oran: number
}

/**
 * Sepet (İyzico ile öde) komisyon oranları — TableIyzicoInstallment.
 * Bu oranlar sitenin GENEL sepet oranlarıdır; ürün bazlı İyzico kampanyası varsa ürün
 * detayındaki oran bunları ezer (kampanyalar Ürün İşlemleri > İyzico Kampanya ekranındadır).
 */
export class IyzicoInstallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: '',
      requesterInfo,
    })
  }

  public async list(): Promise<IIyzicoInstallment[]> {
    this.props.url = 'admin/iyzicoPaymentCampaign/listIyzicoInstallmentDetail'
    return await this.getAsync<IIyzicoInstallment[]>()
  }

  /** Satırların tamamı tek istekte kaydedilir; Id=0 yeni satırdır, sunucuda tek SaveChanges. */
  public async save(rows: IIyzicoInstallment[]): Promise<IIyzicoInstallment[]> {
    this.props.url = 'admin/iyzicoPaymentCampaign/saveIyzicoInstallment'
    return await this.postAsync<IIyzicoInstallment[]>(
      rows.map(r => ({ Id: r.Id, TaksitSayisi: r.TaksitSayisi, Oran: r.Oran }))
    )
  }

  public async delete(id: number): Promise<boolean> {
    this.props.url = `admin/iyzicoPaymentCampaign/deleteIyzicoInstallment/${id}`
    return await this.deleteAsync<boolean>()
  }
}

/**
 * Sepette ve chatbotta görünen vade farkı oranı. Kaydedilen değer HAM komisyon oranıdır;
 * backend (DealerPaymentOperationsService.ListInstallments) bunu brütleştirip yayınlar —
 * aynı formül burada da uygulanır ki admin girdiği değerin bayiye ne olarak görüneceğini bilsin.
 * Oran 100'e eşit/büyükse formül tanımsızdır → null döner (sunucu da bu değeri reddeder).
 */
export const toBasketDisplayRate = (rate: number): number | null => {
  if (!isFinite(rate) || rate < 0 || rate >= 100) return null
  return Math.round((rate / (1 - rate / 100)) * 100) / 100
}
